//
// Module for the security model control
//
rs.module("controls/securitymodel",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        // Initialize the module
        function initialize(jsSelectors, cssClasses, backendUrls, deletePromptTemplateKey, enableEditing) {

            var onNodeSelectedCallback;
            var onNodeDeleteConfirmedCallback;
            var onNodeAddConfirmedCallback;
            var onNodeDownloadConfirmedCallback;

            var securityModel = $.js(jsSelectors.securityModel);

            // Hook up click events for expanding/collapsing nodes
            securityModel.onjs("click", jsSelectors.nodeToggle, _toggleNodeExpanded);
            securityModel.onjs("dblclick", jsSelectors.nodeLink, _toggleNodeExpanded);

            // Helper function to expand/collapse a node
            function _toggleNodeExpanded() {
                $(this).closest(`[data-js=${jsSelectors.nodeContainer}]`).toggleClass(cssClasses.expanded);

                // get all expanded nodes and store them in the hidden field so they can be persisted after a post
                var expandedNodes = securityModel.js(jsSelectors.nodeContainer, { multiple: true }).filter(`.${cssClasses.expanded}`).map(function () {
                    return $(this).data("resourcepath");
                }).get().join(",");

                $.js(jsSelectors.expandedResourcePathsHidden).val(expandedNodes);
            }

            // Hook up click events for selecting a node
            securityModel.onjs("click", jsSelectors.nodeLink, function () {

                if (!$(this).hasClass(cssClasses.selected)) {

                    // toggle selected class for the newly selected node
                    securityModel.js(jsSelectors.nodeLink, { multiple: true }).removeClass(cssClasses.selected);
                    $(this).addClass(cssClasses.selected);

                    // If editing is enabled show the node actions for add/delete next to the selected node
                    if (enableEditing) {
                        securityModel.js(jsSelectors.nodeActions, { multiple: true }).removeClass(cssClasses.visible);
                        $(this).siblings(`[data-js=${jsSelectors.nodeActions}]`).addClass(cssClasses.visible);
                    }

                    // update the hidden field that stores the selected node's resource path
                    var resourcePath = $(this).closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");
                    $.js(jsSelectors.selectedResourcePathHidden).val(resourcePath);

                    // if callback was provided execute node selected callback 
                    if (onNodeSelectedCallback) {
                        onNodeSelectedCallback.call($(this), resourcePath);
                    }
                }
            });

            // Only hook up events related to adding and deleting if editing is enabled
            if (enableEditing) {

                var addResourceModal = $.js(jsSelectors.addResourceModal);

                // Show modal when add resource button is clicked
                securityModel.onjs("click", jsSelectors.nodeAddButton, function () {

                    addResourceModal.js(jsSelectors.secuableResourceNameValidation).hide();
                    addResourceModal.js(jsSelectors.secuableResourceNameInput).val("");
                    addResourceModal.modal("show");
                });

                // Give focus to the resource name field when the modal opens
                addResourceModal.on('shown.bs.modal', function () {
                    addResourceModal.js(jsSelectors.secuableResourceNameInput).focus().val("");
                })

                // Validate and trigger the add confirmed callback when user confirms adding a resource
                addResourceModal.js(jsSelectors.addConfirmButton).click(function () {

                    if (addResourceModal.js(jsSelectors.secuableResourceNameInput).val() != "") {
                        // if callback was provided execute node selected callback 
                        if (onNodeAddConfirmedCallback) {
                            onNodeAddConfirmedCallback.call($(this), addResourceModal.js(jsSelectors.secuableResourceNameInput).val());
                        }
                    }
                    else {
                        addResourceModal.js(jsSelectors.secuableResourceNameValidation).show();
                    }
                });

                // Initiate save on 'Enter' from within the add resource modal
                addResourceModal.js(jsSelectors.secuableResourceNameInput).keypress(function (event) {

                    var keycode = (event.keyCode ? event.keyCode : event.which);
                    if (keycode == '13') {
                        event.preventDefault();
                        addResourceModal.js(jsSelectors.addConfirmButton).click();
                    }

                    // clear error if text has been entered for resource name
                    if (addResourceModal.js(jsSelectors.secuableResourceNameInput).val() != "") {
                        addResourceModal.js(jsSelectors.secuableResourceNameValidation).hide();
                    }
                });

                var downloadModal = $.js(jsSelectors.downloadModelModal);

                securityModel.onjs("click", jsSelectors.nodeDownloadButton, function () {

                    var selectedNode = securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
                    var resourcePath = selectedNode.closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");

                    var confirmationText = $.js(jsSelectors.downloadConfirmationText);
                    confirmationText.text(resourcePath);
                    downloadModal.modal("show");
                });

                // Download the security export file when the user confirms
                downloadModal.js(jsSelectors.downloadConfirmButton).click(function () {

                    var selectedNode = securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
                    var resourcePath = selectedNode.closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");

                    // If callback provided, execute download confirmed
                    if (resourcePath != "") {
                        // if callback was provided execute node download callback 
                        if (onNodeDownloadConfirmedCallback) {
                            onNodeDownloadConfirmedCallback.call($(this), resourcePath);
                        }
                    }

                    downloadModal.modal("hide");
                });

                // Show the delete prompt when the delete icon is clicked
                securityModel.onjs("click", jsSelectors.nodeDeleteButton, function () {

                    // remove any delete prompt that might already be showing
                    $(this).parent().siblings(`[data-js=${jsSelectors.deletePrompt}]`).remove();

                    var promptPopup = $(clientTemplates.render(deletePromptTemplateKey));

                    $(this).parent().after(promptPopup);
                    setTimeout(() => { promptPopup.toggleClass("_visible", true); }, 0);

                    $(document).on(`mouseup`, function (e) {
                        if (!promptPopup.is(e.target) && promptPopup.has(e.target).length === 0 && !securityModel.parent().is(e.target)) {
                            promptPopup.remove();
                        }
                    });
                });

                // Trigger the delete confirmed callback when user confirms the delete
                securityModel.onjs("click", jsSelectors.deleteConfirmButton, function () {

                    // if callback was provided execute delete confirmed callback 
                    if (onNodeDeleteConfirmedCallback) {

                        var selectedNode = securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
                        var resourcePath = selectedNode.closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");

                        onNodeDeleteConfirmedCallback.call($(this), resourcePath);
                    }
                });

                // Remove the delete prompt when the user cancels the delete
                securityModel.onjs("click", jsSelectors.deleteCancelButton, function () {
                    $(this).closest(`[data-js=${jsSelectors.deletePrompt}]`).remove();
                });
            }

            /* ----------- Instance API ------------------ */

            //
            // API function to load a new security model
            //
            function loadSecurityModel(siteSecurityId) {

                return $.get(backendUrls.loadSecurityModel,
                    {
                        securityId: siteSecurityId,
                        enableEditing: enableEditing

                    }).done(function (result) {
                        securityModel.html(result);

                        var selectedNode = securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
                        var resourcePath = selectedNode.closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");

                        $.js(jsSelectors.selectedResourcePathHidden).val(resourcePath);

                        // if callback was provided execute node selected callback 
                        if (onNodeSelectedCallback) {
                            onNodeSelectedCallback.call($(this), resourcePath);
                        }
                    });
            }

            //
            // API function to get the the selected node's resource path
            //
            function getSelectedNodeResourcePath() {
                var selectedNode = securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
                return selectedNode.closest(`[data-js=${jsSelectors.nodeContainer}]`).data("resourcepath");
            }

            //
            // API function to get the the selected node DOM element
            //
            function getSelectedNodeDOM() {
                return securityModel.js(jsSelectors.nodeLink, { multiple: true }).filter("._selected");
            }

            //
            // API function to allow consumers to provide a callback to execute when a node is selected
            //
            function onNodeSelected(onNodeSelected) {
                onNodeSelectedCallback = onNodeSelected;
            }

            //
            // API function to allow consumers to provide a callback to execute when 
            // a user confirms the download
            //
            function onNodeDownloadConfirmed(onNodeDownloadConfirmed) {
                onNodeDownloadConfirmedCallback = onNodeDownloadConfirmed;
            }

            //
            // API function to allow consumers to provide a callback to execute when 
            // a user confirms the addition of a node
            //
            function onNodeAddConfirmed(onNodeAddConfirmed) {
                onNodeAddConfirmedCallback = onNodeAddConfirmed;
            }

            //
            // API function to allow consumers to provide a callback to execute when 
            // a user confirms the delete of a node
            //
            function onNodeDeleteConfirmed(onNodeDeleteConfirmed) {
                onNodeDeleteConfirmedCallback = onNodeDeleteConfirmed;
            }

            // Exported instance API
            return {
                loadSecurityModel,
                getSelectedNodeResourcePath,
                getSelectedNodeDOM,
                onNodeSelected,
                onNodeAddConfirmed,
                onNodeDeleteConfirmed,
                onNodeDownloadConfirmed
            };
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);